import { c as _c } from "react/compiler-runtime";
import { Icon } from "@iconify/react";
export default function ServicesPromo(t0) {
  const $ = _c(4);
  const {
    servs
  } = t0;
  let t1;
  if ($[0] !== servs) {
    t1 = servs?.length > 0 && servs?.map(_temp);
    $[0] = servs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <section className="services-promo py-2 lg:py-3"><div className="max-w-7xl mx-auto px-2"><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">{t1}</div></div></section>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(serv, index) {
  return <div className="bg-white shadow-xs rounded text-center p-2 lg:p-4 border border-gray-200" key={index}><Icon icon={serv?.icon} fontSize="3rem" className="mx-auto" /><div className="font-heading text-xl mt-2 text-primary">{serv?.title}</div><div className="text-base text-secondary">{serv?.subtext}</div></div>;
}